import axios from 'axios';
import { useEffect, useState } from 'react'
import { CircularProgress, Pagination } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import {ProjectConfig} from 'Global';
import TopBar from 'elements/TopBar/TopBar';
import FiltersApplied from 'elements/Filters/FiltersApplied';

import {ReactComponent as Ic_multimedia_audio} from 'icons/ic_multimedia_audio.svg';
import {ReactComponent as Ic_multimedia_video} from 'icons/ic_multimedia_video.svg';
import {ReactComponent as Ic_multimedia_file} from 'icons/ic_multimedia_file.svg';
import Cookies from 'universal-cookie';
import { useLabels, getMultimediaLabel } from 'hooks/useLabels';



export default function MultimediaList(props:any) {

  /*================================================
  FILTERS
  =================================================*/
  const filters = [
    {type: "text", label: "Nombre", name: "title", value: ""}
  ]
  const [filtersValues, setFiltersValues] = useState<any>({});

  const setFilters = (tempFilters: any) => {
    setFiltersValues(tempFilters);
  }
  /*================================================= 
  ==================================================*/


  const [loading, setLoading] = useState(false); 
  const [list, setList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const currentPage=parseInt(localStorage.getItem('page') || "1");

  const [page, setPage] = useState(currentPage);

  const cookies = new Cookies();
  const user_id = cookies.get('user_id');
  const modulo  = 'Multimedia';
  const lang_id = localStorage.getItem('lang_id') || '1';
  const { labels } = useLabels();
  

  /*=========================================================
  LOAD LIST            
  =========================================================*/

  useEffect(() => {
    props.setLoading(true);
      axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'multimedia_list',
          filters: filtersValues,
          page: page,
          user_id: user_id,
          modulo: modulo,
          lang_id: lang_id
        }
      })
        .then((response) => {
          setList(response.data.list)
          setTotalPages(response.data.total_pages)
          props.setLoading(false);
           
        })
        .catch((err) => {
          console.log(err.data);
        })
        localStorage.setItem('page', page.toString())
    
  }, [page, filtersValues])
  /*=========================================================*/


  return (
    <div id='Multimedia' className='module_container'>
      
      <div className="module_topBar">
        <TopBar title={getMultimediaLabel(labels, 'multimedia_titulo')} filters={filters} setFilters={setFilters}/>
      </div>
      

      <FiltersApplied filtersValues={filtersValues} setFiltersValues={setFiltersValues}/>
     

      
      <div className='module_content'>
        <div id="task_list_container" className="flex_column">
                  {list.map((list_item,key) => (

                      <Link className='CardListPadding' key={key} to={'/multimedia/'+list_item.multimedia_id} onClick={()=> {props.setLoading(true)}}>    
                        <div className='CardListLeft'>
                          {list_item.type === 'audio' && <Ic_multimedia_audio/>}
                          {list_item.type === 'video' && <Ic_multimedia_video/>}
                          {list_item.type === 'file' && <Ic_multimedia_file/>}
                        </div>
                        
                        <div className='CardListRight'>
                          <span className='CardListTitle'>{list_item.title}</span>
                          <span className='CardListSubTitle'>{list_item.date}</span>
                        </div>
                      </Link>
                  ))}

          
          {/* <Pagination count={total_pages} page={page}  onChange={(event, value) => {
            setPage(value)
          }
          } 
          color="primary"
          style={{"marginTop": "20px","alignSelf": "center"}}
          /> */}
 
        </div>
      </div>
    </div>
  );
};


